import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { clearPrivateChat } from 'actions/broadcast';
import { logout, notificationBadgeList } from 'actions/login';
import { setScrollPosition, setWidthOfMenu, showMenu, toggleSider } from 'actions/layout';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router';
import { Api } from 'services';
import { locations } from './locations';
import LogoutConfirm from './logoutConfirm';
import { itemsGrp, menuItems } from './menuItems';
import './styles.css';
import { Dropdown, Tooltip, Typography } from 'antd';
import UserAvatar from 'components/userAvatar';
import { setIsLogoutClicked } from 'actions/studentMarketPlace';
import { urlWithoutMenu } from 'services/urlWithoutMenu';

import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import chevronLeft from "../Assets/layout/newFilledIcons/chevron-double-left.svg";
import chevronRight from "../Assets/layout/newFilledIcons/chevron-double-right.svg";
import addUserEnabled from "../Assets/layout/newFilledIcons/add-user-enabled.svg";
import addFeeEnabled from "../Assets/layout/newFilledIcons/add-fee-enabled.svg";
import addScheduleEnabled from "../Assets/layout/newFilledIcons/add-schedule-enabled.svg";
import addAnnounceEnabled from "../Assets/layout/newFilledIcons/add-announcement-enabled.svg";
import markAttendanceEnabled from "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg";
import applyLeaveEnabled from "../Assets/layout/newFilledIcons/apply-leave-enabled.svg";
import createCourseEnabled from "../Assets/layout/newFilledIcons/cretae-course-enabled.svg";
import addResourceEnabled from "../Assets/layout/newFilledIcons/add-resource-enabled.svg";
import addTestEnabled from "../Assets/layout/newFilledIcons/add-test-enabled.svg";
import pencilOutlined from "../Assets/layout/newFilledIcons/pencil.svg";
import menuCollapsed from "../Assets/layout/newFilledIcons/collapsed.svg";
import bellIcon from "../Assets/layout/newFilledIcons/bell.svg";

import AulasSubscriptionModal from 'pages/common/aulasSubsriptionModal'


import QuickAccessModal from './quickAccessModal';
import { fetchNotificationsForMenu, fetchUserMenuSettingsData, setMenuSettingsData, setQuickAccessItem, updateUserMenuSettings } from 'actions/userManagementV2';
import MenuContext from 'antd/lib/menu/MenuContext';
import CollapseQuickAccessModal from './collapseQuickAccessModal';
import { fetchNotifications } from 'actions/notification';
import { setCourseTypeName } from 'actions/courseManagement';
import CreateCourseModal from './createCourseModal';
import ProfileMenu from './profileMenu';
import { CollapsedProfileMenu } from './collapsedProfileMenu';
import { attendanceRequirementDetail, getAttendanceDashBoardData } from 'actions/attendanceNew';
import { setSubscriptionModal } from 'actions/schedule';
import Lottie from 'react-lottie';
import loaderJson from '../Assets/loader.json';






const SideMenu = React.memo((props) => {

    const { user,
        userDetails,
        notifyBadgeListCount,
        orgData,
        logout,
        clearPrivateChat,
        notificationBadgeList,
        collapsed,
        toggleSider,
        authenticated,
        setWidthOfMenu,
        setIsLogoutClicked,
        scrollPosition,
        setScrollPosition,
        showMenu,
        myCoursePage, myCoursePageForTeacher,
        fetchUserMenuSettingsData,
        userMenusettingsData,
        updateUserMenuSettings,
        menuSettingsData,
        fetchNotificationsForMenu,
        setQuickAccessItem,
        fetchNotifications,
        notification,
        setCourseTypeName,
        isLogoutClicked,
        setMenuSettingsData,
        courseDashboardData,
        attendanceDataContainer,
        getAttendanceDashBoardData,
        getattendanceRequirement,
        attendanceRequirementDetail,
        setSubscriptionModal,
        sizeOfContents,
        subscriptionModal


    } = props;

    const setKeyBylocation = () => {
        locations.forEach((item, i) => {
            if (location.pathname === item.path) {
                setSelectedKey(item.key);
            }
        });
    };

    const setKeyByUrlPath = () => {
        urlWithoutMenu.forEach((item, i) => {
            if (location.pathname === item.urlPath) {
                showMenu(false)
            }
        });

    }

    let allItems

    console.log('getattendanceRequirement', getattendanceRequirement);


    const allOptions = [
        { id: 0, index: 0, label: "Add user", enabledIcon: "../Assets/layout/newFilledIcons/add-user-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-user-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addUserWhite.svg" },
        { id: 1, index: 1, label: "Add fee request", enabledIcon: "../Assets/layout/newFilledIcons/add-fee-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-fee-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addFeeWhite.svg" },
        { id: 2, index: 2, label: "Add schedule", enabledIcon: "../Assets/layout/newFilledIcons/add-schedule-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-schedulle-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addScheduleWhite.svg" },
        { id: 3, index: 3, label: "Add announcement", enabledIcon: "../Assets/layout/newFilledIcons/add-announcement-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-announcement-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addAnnouncementWhite.svg" },
        { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
        { id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" },
        { id: 6, index: 6, label: "Create course", enabledIcon: "../Assets/layout/newFilledIcons/cretae-course-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/create-course-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/createCourseWhite.svg" },
        { id: 7, index: 7, label: "Add resource", enabledIcon: "../Assets/layout/newFilledIcons/add-resource-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-resource-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addResourceWhite.svg" },
        { id: 8, index: 8, label: "Add test", enabledIcon: "../Assets/layout/newFilledIcons/add-test-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-test-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addTestwhite.svg" },
    ]

    const iconMapEnabled = {
        "Add user": addUserEnabled,
        "Add fee request": addFeeEnabled,
        "Add schedule": addScheduleEnabled,
        "Add announcement": addAnnounceEnabled,
        "Mark attendance": markAttendanceEnabled,
        "Apply leave": applyLeaveEnabled,
        "Create course": createCourseEnabled,
        "Add resource": addResourceEnabled,
        "Add test": addTestEnabled,
    };

    const getAllItems = () => {
        // SuperAdmin and Admin get all items
        if (Object.keys(user).length !== 0 && (user?.privilage?.includes('SuperAdmin'))) {
            return allOptions;
        }

        // Define role-based items
        const roleBasedItems = {
            ['Teacher']: [{ id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" }
                , { id: 8, index: 8, label: "Add test", enabledIcon: "../Assets/layout/newFilledIcons/add-test-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-test-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addTestwhite.svg" },
            { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },],
            ['Data Operator']: [
                { id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" },
                { id: 8, index: 8, label: "Add test", enabledIcon: "../Assets/layout/newFilledIcons/add-test-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-test-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addTestwhite.svg" },
                { id: 7, index: 7, label: "Add resource", enabledIcon: "../Assets/layout/newFilledIcons/add-resource-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-resource-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addResourceWhite.svg" },
                { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },],
            ['Marketing']: [{ id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" },
            { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
            ],
            ['Operation']: [{ id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" },
            { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
            ],
            ['AttendanceMarker']: [{ id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
            { id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" }],
            ['FeeManager']: [{ id: 1, index: 1, label: "Add fee request", enabledIcon: "../Assets/layout/newFilledIcons/add-fee-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-fee-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addFeeWhite.svg" },
            { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
            { id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" }],
            ['Planner']: [{ id: 2, index: 2, label: "Add schedule", enabledIcon: "../Assets/layout/newFilledIcons/add-schedule-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-schedulle-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addScheduleWhite.svg" },
            { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
            { id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" }],
            ['LeaveManager']: [{ id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" },
            { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
            ],
            ['Admin']: [
                { id: 0, index: 0, label: "Add user", enabledIcon: "../Assets/layout/newFilledIcons/add-user-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-user-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addUserWhite.svg" },
                { id: 2, index: 2, label: "Add schedule", enabledIcon: "../Assets/layout/newFilledIcons/add-schedule-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-schedulle-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addScheduleWhite.svg" },
                { id: 3, index: 3, label: "Add announcement", enabledIcon: "../Assets/layout/newFilledIcons/add-announcement-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-announcement-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addAnnouncementWhite.svg" },
                { id: 4, index: 4, label: "Mark attendance", enabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/mark-attendance-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/markAttendanceWhite.svg" },
                { id: 5, index: 5, label: "Apply leave", enabledIcon: "../Assets/layout/newFilledIcons/apply-leave-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/apply-leave-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/applyLeaveWhite.svg" },
                { id: 6, index: 6, label: "Create course", enabledIcon: "../Assets/layout/newFilledIcons/cretae-course-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/create-course-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/createCourseWhite.svg" },
                { id: 7, index: 7, label: "Add resource", enabledIcon: "../Assets/layout/newFilledIcons/add-resource-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-resource-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addResourceWhite.svg" },
                { id: 8, index: 8, label: "Add test", enabledIcon: "../Assets/layout/newFilledIcons/add-test-enabled.svg", disabledIcon: "../Assets/layout/newFilledIcons/add-test-disabled.svg", whiteIcon: "../Assets/layout/newFilledIcons/addTestwhite.svg" },
            ],
        }

        let selectedItems = [];

        // Add items based on user role
        Object.keys(user).length !== 0 && user.role.forEach((role) => {
            if (roleBasedItems[role]) {
                selectedItems = [...selectedItems, ...roleBasedItems[role]];
            }
        });

        // Add items based on privileges
        Object.keys(user).length !== 0 && user?.privilage?.forEach((privilege) => {
            if (roleBasedItems[privilege]) {
                selectedItems = [...selectedItems, ...roleBasedItems[privilege]];
            }
        });

        const uniqueItems = selectedItems.filter(
            (item, index, self) => self.findIndex(i => i.id === item.id) === index
        );

        return uniqueItems;
    };

    allItems = getAllItems().filter(item => {
        if (item.label === 'Mark attendance' && (attendanceDataContainer?.attendanceSystem === 'onSite' && getattendanceRequirement?.attendanceSystem === 'onSite')) {
            return false;
        }
        return true;
    });
    // allItems = allOptions



    const [selectedItems, setSelectedItems] = useState([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [miniProfileMenu, setMiniProfileMenu] = useState(false);
    const [createCourseModalVisible, setCreateCourseModalVisible] = useState(false);
    const [dropdownVisibleCollapse, setDropdownVisibleCollapse] = useState(false);
    const [editClick, setEditClick] = useState(false);
    const [delayedShowProfile, setDelayedShowProfile] = useState(false);
    const [pageLoader, togglePageLoader] = useState(false);



    useEffect(() => {
        const userId = user?.id
        // const isUserEmpty = Object.keys(user).length === 0;

        if (!dropdownVisible) {

            // gate on the session, not on the marketplace's logout flag
            if (authenticated && Object.keys(user).length != 0) {

                fetchUserMenuSettingsData(userId, () => { }, () => {
                    setSelectedItems(userMenusettingsData?.menuSettings);
                    fetchNotifications(() => { });
                    notificationBadgeList();
                    getAttendanceDashBoardData(() => { });
                    attendanceRequirementDetail()

                })
                setSelectedItems(userMenusettingsData?.menuSettings);

            }

        }
        // fetchNotificationsForMenu(()=>{})

    }, [dropdownVisible, authenticated, user?.id]);
    const location = window.location;
    const divRef = useRef(null);
    const menuRef = useRef(null);
    const profileTimeoutRef = useRef(null);


    useEffect(() => {
        setKeyBylocation();
        setKeyByUrlPath()

    }, [location.pathname]);



    useEffect(() => {
        if (divRef.current) {
            const divWidth = divRef.current.clientWidth;
            setWidthOfMenu(divWidth);
        }
    }, [collapsed]);

    const [confirmLogoutVisible, setConfirmLogoutVisible] = useState(false);
    const [selectedKey, setSelectedKey] = useState(1);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [hovered, setHovered] = useState(false);
    const history = useHistory();
    const [localSelected, setLocalSelected] = useState(userMenusettingsData?.menuSettings);
    useEffect(() => {
        return () => {
            if (menuRef.current) {
                setScrollPosition(menuRef.current.scrollTop);
            }
        }
    }, []);

    useEffect(() => {
        if (userMenusettingsData?.menuSettings) {
            setLocalSelected(userMenusettingsData.menuSettings);
            setSelectedItems(userMenusettingsData.menuSettings);
        }
    }, [userMenusettingsData]);

    useEffect(() => {
        if (menuRef.current) {
            menuRef.current.scrollTop = scrollPosition;
        }
    }, [scrollPosition]);

    useEffect(() => {
        menuSettingsData?.filter(item => item !== null);
    }, [menuSettingsData])


    const handleLogout = () => {
        clearPrivateChat();
        const reason = {
            type: 'Manual'
        }
        logout(history, reason);
        setIsLogoutClicked(true);
    };



    const handleDropdownVisibleChangeCollapse = (visible) => {
        setDropdownVisibleCollapse(visible);
    };



    const handleDropdownVisibleChange = (visible) => {
        setDropdownVisible(visible);

        if (!visible) {
            setEditClick(false);
            const userId = user?.id;
            if (!userId) return;

            setMenuSettingsData(localSelected);

            togglePageLoader(true);
            let isSuccessful = false;
            updateUserMenuSettings(userId, () => {
                if (!isSuccessful) {
                    togglePageLoader(false);
                }
            }, () => {
                isSuccessful = true;
                fetchUserMenuSettingsData(userId, () => {
                    togglePageLoader(false);
                }, () => {
                    // success callback
                })
            })
        }
    };


    const [isVisible, setIsVisible] = useState(false); // Controls when ProfileMenu is mounted


    const handleMouseEnter = () => {
        if (!collapsed) {
            if (profileTimeoutRef.current) {
                clearTimeout(profileTimeoutRef.current);
                profileTimeoutRef.current = null;
            }
            setIsVisible(true);
            setShowProfileMenu(true);
            setDelayedShowProfile(true);
        }
    };
    // console.log('showProfileMenu1',showProfileMenu,collapsed,isVisible);


    const handleMouseLeave = () => {
        if (!collapsed) {
            setShowProfileMenu(false); // Hide the profile menu first
            if (profileTimeoutRef.current) {
                clearTimeout(profileTimeoutRef.current);
            }
            profileTimeoutRef.current = setTimeout(() => {
                setDelayedShowProfile(false);
                setIsVisible(false); // Unmount after animation finishes
                profileTimeoutRef.current = null;
            }, 400);
        }
    };

    const handleCancel = () => {
        setSubscriptionModal(false)
    }

    return (
        <div ref={divRef} style={{
            position: "relative",
            height: "100%", width: collapsed ? "5%" : "20%",
            minWidth: collapsed ? "90px" : "200px", maxWidth: collapsed ? "110px" : "270px",
            background: "#FAFAFA", padding: "20px 0px",
            transition: "width 0.8s ease, min-width 0.8s ease, max-width 0.8s ease",
            // overflow:'hidden',
        }} className="r-c-c-c">


            {hovered && collapsed && (
                <div
                    className='mini-sidebar-toggle'
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleSider(!collapsed);
                        setShowProfileMenu(false)
                        setDelayedShowProfile(false)
                        setIsVisible(false);
                    }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    <img src={chevronRight} alt="Toggle sidebar" />
                </div>
            )}

            {hovered && !collapsed && !showProfileMenu && (
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleSider(!collapsed);
                        setHovered(false);
                    }}
                    className="sidebar-toggle"
                    style={{
                        position: 'absolute',
                        top: '45px',
                        left: 'calc(88% + 5px - 14px)',
                        right: 'auto',
                        zIndex: 200
                    }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    <img src={chevronLeft} alt="Toggle sidebar" />
                </div>
            )}

            <div className='menuWrapper flex-column' id="sideMenuId"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ position: 'relative', }}
            >

                <div className={`top-part-profile display-flex m-l-20 m-t-20 cursor-pointer ${collapsed ? "collapsed" : ""}`}
                    style={{
                        display: 'flex',
                        position: showProfileMenu ? 'absolute' : 'relative',
                        top: showProfileMenu ? '0px' : 'auto',
                        left: showProfileMenu ? '0px' : 'auto',
                        width: showProfileMenu ? '100%' : '89%',
                        zIndex: showProfileMenu ? 1001 : 'auto',
                        backgroundColor: '#ffffff',
                        marginLeft: showProfileMenu ? 0 : 18,
                        marginTop: showProfileMenu ? 0 : 17,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                        paddingTop: showProfileMenu ? 17 : 0,
                        paddingBottom: showProfileMenu ? 20 : 0,
                        paddingLeft: showProfileMenu ? 18 : 0,
                    }}
                >
                    <Tooltip placement="right" color='#FFF' onClick={() => history.push("/")} >
                        <div className='' style={{ marginLeft: showProfileMenu && !collapsed && 15, display: 'block' }}>
                            <img style={{ borderRadius: orgData?.title == 'ashreya' && orgData?.logo ? '' : '50%', height: "5vmin", width: "5vmin" }} src={`${Api._s3_url}${orgData?.logo || "defaultLogo.png"}`} alt="" />
                        </div>
                    </Tooltip>
                    {
                        collapsed ?
                            null
                            :
                            <div className='orgTitle' onClick={() => history.push("/")} style={{display: 'flex', alignItems:'center'}}>
                                <Typography.Paragraph
                                    ellipsis={{ tooltip: true, rows: 2 }}
                                    className='orgTitle'
                                    style={{margin:0,maxWidth:"80%",fontSize:'1rem'}}
                                >
                                    {orgData?.title}
                                </Typography.Paragraph>
                            </div>
                    }
                </div>
                {
                    !collapsed && !showProfileMenu &&
                    <div style={{ marginTop: 5, }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontFamily: 'Roboto, sans-serif', alignItems: 'center', width: '88%', marginLeft: '6%', marginBottom: 5 }}>
                            <div style={{ color: '#636363', fontWeight: 500, fontSize: 11 }}>QUICK ACCESS</div>

                            {allItems.length > 1 ?
                                <div className='custom-dropdown-position'>
                                    {/* <DndProvider backend={HTML5Backend}> */}
                                    <Dropdown
                                        overlay={<QuickAccessModal
                                            userMenusettingsData={userMenusettingsData}
                                            selectedItems={selectedItems}
                                            allItems={allItems}
                                            setSelectedItems={setSelectedItems}
                                            setEditClick={setEditClick}
                                            editClick={editClick}
                                            localSelected={localSelected}
                                            setLocalSelected={setLocalSelected}
                                            user={user}
                                        // onChange={handleItemsChange}
                                        />}
                                        visible={dropdownVisible}
                                        onVisibleChange={handleDropdownVisibleChange}
                                        trigger={['click']}
                                        placement='bottomRight'
                                        overlayStyle={{
                                            width: "290px",
                                            marginLeft: 80
                                        }}
                                    >

                                        <img src={pencilOutlined} style={{ height: 17, width: 17, marginBottom: 3, cursor: 'pointer' }} onClick={() => { setEditClick(false) }} />
                                    </Dropdown>
                                    {/* </DndProvider> */}
                                </div>
                                :
                                <></>}



                            {/* <div ><img src={pencilOutlined} style={{ height: 17, width: 17, marginBottom: 3 }} onClick={() => setIsModalVisible(true)} /></div> */}
                        </div>

                        <div className="quick-access">

                            {userMenusettingsData?.menuSettings && userMenusettingsData?.menuSettings
                                .map((selected) =>
                                    allItems.find((item) => item?.label === selected?.label)
                                )
                                .filter(Boolean)
                                .map((item, index) => (
                                    <div key={index} className="quick-access-menu-item"
                                        onClick={() => {

                                            if (item?.label == 'Add user') {
                                                setQuickAccessItem("addUser", true)
                                                history.push({
                                                    pathname: "/user-management", state: {
                                                        key: {
                                                            fromSideMenu: true,
                                                        }
                                                    }
                                                })
                                            } else if (item?.label == 'Add fee request') {
                                                setQuickAccessItem("addFee", true)
                                                history.push({
                                                    pathname: "/fee-management", state: {
                                                        key: {
                                                            fromSideMenu: true,
                                                        }
                                                    }
                                                })
                                            } else if (item?.label == 'Add schedule') {
                                                setQuickAccessItem("addSchedule", true)
                                                history.push({
                                                    pathname: "/schedule", state: {
                                                        key: {
                                                            fromSideMenu: true,
                                                        }
                                                    }
                                                })
                                            } else if (item?.label == 'Add announcement') {
                                                setQuickAccessItem("addAnnounce", true)
                                                history.push({
                                                    pathname: "/announcement", state: {
                                                        key: {
                                                            fromSideMenu: true,
                                                        }
                                                    }
                                                })
                                            } else if (item?.label == 'Create course') {
                                                // setCourseTypeName('liveCourses')
                                                // history.push({
                                                //     pathname: "/add-live-courses", state: {
                                                //         key: {
                                                //             fromSideMenu: true,
                                                //         }
                                                //     }
                                                // })
                                                setCreateCourseModalVisible(true)
                                            } else if (item?.label == 'Add test') {
                                                setQuickAccessItem("addTest", true)

                                                history.push({
                                                    pathname: "/test", state: {
                                                        key: {
                                                            fromSideMenu: true,
                                                        }
                                                    }
                                                })
                                            } else if (item?.label == 'Add resource') {
                                                setQuickAccessItem("addResource", true)
                                                history.push({
                                                    pathname: "/digital-library/division-card", state: {
                                                        key: {
                                                            fromSideMenu: true,
                                                        }
                                                    }
                                                })
                                            } else if (item?.label == 'Mark attendance') {
                                                setQuickAccessItem("markAttendance", true)
                                                history.push({
                                                    pathname: "/user-profile/others",
                                                })
                                            } else if (item?.label == 'Apply leave') {
                                                setQuickAccessItem("applyLeave", true)
                                                history.push({
                                                    pathname: "/user-profile/others",
                                                })
                                            }

                                        }}
                                    >


                                        <Tooltip mouseEnterDelay={0.6}
                                            title={item?.label === 'Apply leave' ?
                                                (user?.privilage?.length && user.privilage.includes('SuperAdmin'))
                                                    ? 'Mark leave'
                                                    : 'Apply leave'
                                                : item?.label === 'Mark attendance' ?
                                                    (user?.privilage?.length && user.privilage.includes('SuperAdmin'))
                                                        ? 'Mark attendance'
                                                        : 'Request attendance'
                                                    : item.label}
                                        >
                                            <img
                                                className='quick-image-hover'
                                                src={iconMapEnabled[item?.label] || addUserEnabled}
                                                alt={`${item?.label} icon`}
                                            />
                                        </Tooltip>
                                    </div>
                                ))}

                        </div>
                    </div>

                }
                {
                    collapsed &&
                    <div className="quick-access" style={{ marginLeft: '23.5%', marginTop: 10, width: 'fit-content', padding: '8% 3% 10% 13%' }}>
                        <div className="quick-access-menu-item">
                            <Dropdown
                                overlay={<CollapseQuickAccessModal
                                    items={userMenusettingsData?.menuSettings}
                                    setDropdownVisible={setDropdownVisible}
                                    setDropdownVisibleCollapse={setDropdownVisibleCollapse}
                                    userId={user.id}
                                    allItems={allItems}
                                    updateUserMenuSettings={updateUserMenuSettings}
                                    fetchUserMenuSettingsData={fetchUserMenuSettingsData}
                                    userMenusettingsData={userMenusettingsData}
                                    setCourseTypeName={setCourseTypeName}
                                    setQuickAccessItem={setQuickAccessItem}
                                    setEditClick={setEditClick}
                                    editClick={editClick}
                                    dropdownVisibleCollapse={dropdownVisibleCollapse}
                                    localSelected={localSelected}
                                    setLocalSelected={setLocalSelected}
                                    user={user}
                                    setCreateCourseModalVisible={setCreateCourseModalVisible}
                                    togglePageLoader={togglePageLoader}
                                // onChange={handleItemsChange}
                                />}
                                visible={dropdownVisibleCollapse}
                                onVisibleChange={handleDropdownVisibleChangeCollapse}
                                trigger={['click']}
                                // placement='bottomRight'
                                overlayStyle={{
                                    width: "270px",
                                    // left:100,
                                    top: 100
                                }}
                            >
                                <img style={{ cursor: 'pointer' }} src={menuCollapsed} />
                            </Dropdown>

                        </div>
                    </div>
                }
                <div ref={menuRef} className='m-t-10 scroll-bar-universal'
                    style={{
                        // border:'1px solid red',
                        height: showProfileMenu ? '90%' : '72.5%',
                        position: 'relative',
                        zIndex: showProfileMenu ? 999 : 'auto',
                        transform: showProfileMenu ? 'translateY(-150px)' : 'translateY(0)', // Adjust 200px based on ProfileMenu height
                        transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), height 0.4s cubic-bezier(0.4, 0, 0.2, 1), padding-top 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        paddingTop: showProfileMenu ? 145 : 0 // for handling flex-clmn

                    }}>
                    {Object.keys(menuItems(props)).map((grp, index) => itemsGrp(grp, index, props, selectedKey, collapsed, notifyBadgeListCount, setHovered, setShowProfileMenu))}
                </div>
                {/* <div style={{ margin: "0 20px 0 20px" }} /> */}
                <div className='flex-1 display-flex m-b-10 cursor-pointer' style={{
                    alignItems: "flex-end",
                    padding: "0 20px ",
                    width: "100%",
                    overflow: 'visible',
                }}
                    onMouseLeave={handleMouseLeave}
                >
                    <div className='r-jsb' style={{ width: "100%", alignItems: "center", marginBottom: !isVisible ? 6 : 0 }}
                    >
                        {
                            isVisible && !collapsed &&
                            <ProfileMenu user={user}
                                userDetails={userDetails}
                                setConfirmLogoutVisible={setConfirmLogoutVisible}
                                setIsVisible={setIsVisible}
                                setShowProfileMenu={setShowProfileMenu}
                                collapsed={collapsed}
                                notificationCount={notifyBadgeListCount > 9 ? '9+' : notifyBadgeListCount}
                                onLogout={() => setConfirmLogoutVisible(true)}
                                onNotificationClick={() => history.push('/notifications-home')}
                                showProfileMenu={showProfileMenu}
                                handleMouseLeave={handleMouseLeave}
                                isVisible={isVisible}
                                onProfileClick={() => history.push("/account-settings")}
                            />
                        }
                        <div style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            visibility: delayedShowProfile ? 'hidden' : 'visible'
                        }}>
                            <div className='r-ac' style={{ flex: 1 }}>
                                <div style={{ marginLeft: collapsed ? 5 : 0, position: "relative", }}
                                    onMouseEnter={() => { collapsed && setMiniProfileMenu(true) }}
                                 >
                                    <UserAvatar size="5vmin" shape="circle" name={user.name} img={user.image == "default.png" ? "" : `${Api._s3_url}${user.image}`} backgroundColor={userDetails?.backgroundColor || user?.backgroundColor} textColor={userDetails?.textColor || user?.textColor} />
                                    {collapsed && notifyBadgeListCount > 0 && <span className="notification-count">{notifyBadgeListCount > 9 ? '9+' : notifyBadgeListCount}</span>}
                                </div>
                                {collapsed ?
                                    null
                                    :
                                    <div onMouseEnter={handleMouseEnter} style={{ flex: 1, height: '40px', display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>
                                        <Typography.Text
                                            ellipsis={{ tooltip: true }}
                                            className='userName'
                                            style={{

                                                maxWidth: 120,
                                                width: 'fit-content',
                                            }}
                                        >
                                            {user.name}
                                        </Typography.Text>

                                    </div>

                                }
                            </div>
                            <div onClick={e => { e.isPropagationStopped(); }} style={{ zIndex: 100 }} >
                                {collapsed ?
                                    null
                                    :

                                    <div className="notification-bell"
                                        onClick={() => history.push('/notifications-home')}>
                                        <img
                                            className="bell-icon"
                                            style={{ cursor: "pointer", height: 22, width: 22 }}
                                            src={bellIcon}
                                            alt="Notification Bell"
                                        />
                                        {notifyBadgeListCount > 0 && <span className="notification-count">{notifyBadgeListCount > 9 ? '9+' : notifyBadgeListCount}</span>}
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>


            </div>
            <CollapsedProfileMenu
                user={user}
                userDetails={userDetails}
                visible={miniProfileMenu}
                setConfirmLogoutVisible={setConfirmLogoutVisible}
                collapsed={collapsed}
                notificationCount={notifyBadgeListCount > 9 ? '9+' : notifyBadgeListCount}
                onLogout={() => { setConfirmLogoutVisible(true); setMiniProfileMenu(false) }}
                onNotificationClick={() => { history.push('/notifications-home'); setMiniProfileMenu(false) }}
                onProfileClick={() => { history.push("/account-settings"); setMiniProfileMenu(false) }}
                setMiniProfileMenu={setMiniProfileMenu}
            />

            <LogoutConfirm
                visible={confirmLogoutVisible}
                onCancel={() => setConfirmLogoutVisible(false)}
                onConfirm={() => handleLogout(history)}
            />
            <CreateCourseModal
                visible={createCourseModalVisible}
                setCreateCourseModalVisible={setCreateCourseModalVisible}
                setCourseTypeName={setCourseTypeName}
                onClose={() => setCreateCourseModalVisible(false)}
                courseDashboardData={courseDashboardData}
                sizeOfContents={sizeOfContents}
                setSubscriptionModal={setSubscriptionModal}
            />
            <AulasSubscriptionModal
                isModalVisible={subscriptionModal}
                handleCancel={handleCancel}
            />
            {pageLoader && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: 99999,
                    backgroundColor: 'rgba(255, 255, 255, 0.60)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingLeft: collapsed ? '90px' : '270px',
                    boxSizing: 'border-box'
                }}>
                    <div style={{ height: "100px", width: "100px", backgroundColor: "transparent" }}>
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: loaderJson,
                                rendererSettings: {
                                    preserveAspectRatio: 'xMidYMid slice',
                                },
                            }}
                            height={'100%'}
                            width={'100%'}
                        />
                    </div>
                </div>
            )}
        </div>
    );
})

const mapStateToProps = (state) => {
    const { collapsed, scrollPosition } = state.layout;
    const { myCoursePage, myCoursePageForTeacher } = state.studentMarketPlace
    const {
        notifyBadgeList,
        notifyBadgeListCount,
        rejectLoader,
        approveLoader,
    } = state.login;
    const { userMenusettingsData, menuSettingsData, notificationMenu } = state.userManagementV2
    const { user, authenticated } = state.session;
    const { orgData } = state.loginNew;
    const { notification } = state.notification
    const { isLogoutClicked } = state.studentMarketPlace
    const { courseDashboardData } = state.courseManagement;
    const { attendanceDataContainer, getattendanceRequirement } = state.attendanceNew
    const { sizeOfContents } = state.digitalLibrary;
    const { subscriptionModal } = state.schedule;
    const { userDetails } = state.profileNew;

    return {
        collapsed,
        user,
        userDetails,
        notifyBadgeList,
        notifyBadgeListCount,
        rejectLoader,
        approveLoader,
        orgData,
        authenticated,
        scrollPosition,
        myCoursePage, myCoursePageForTeacher,
        userMenusettingsData, menuSettingsData, notificationMenu, notification, isLogoutClicked, courseDashboardData, attendanceDataContainer, getattendanceRequirement,sizeOfContents,subscriptionModal
    };
};

const mapDispatchToProps = (dispatch) => ({
    setCourseTypeName: (val) => dispatch(setCourseTypeName(val)),
    logout: (history, reason) => dispatch(logout(history, reason)),
    notificationBadgeList: () => dispatch(notificationBadgeList()),
    clearPrivateChat: () => dispatch(clearPrivateChat()),
    toggleSider: (val) => dispatch(toggleSider(val)),
    setWidthOfMenu: (val) => dispatch(setWidthOfMenu(val)),
    setIsLogoutClicked: (val) => dispatch(setIsLogoutClicked(val)),
    setScrollPosition: (val) => dispatch(setScrollPosition(val)),
    showMenu: (bool) => dispatch(showMenu(bool)),
    setMenuSettingsData: (res) => dispatch(setMenuSettingsData(res)),
    setQuickAccessItem: (res) => dispatch(setQuickAccessItem(res)),
    fetchUserMenuSettingsData: (userId, callback, successCallBack) => dispatch(fetchUserMenuSettingsData(userId, callback, successCallBack)),
    updateUserMenuSettings: (userId, callback, successCallBack) => dispatch(updateUserMenuSettings(userId, callback, successCallBack)),
    fetchNotificationsForMenu: (callback) => dispatch(fetchNotificationsForMenu(callback)),
    fetchNotifications: (callback) => dispatch(fetchNotifications(callback)),
    getAttendanceDashBoardData: callback => dispatch(getAttendanceDashBoardData(callback)),
    attendanceRequirementDetail: () => dispatch(attendanceRequirementDetail()),
    setSubscriptionModal: (res) => dispatch(setSubscriptionModal(res)),



});

const SiderMenu = withRouter(SideMenu);

export default connect(mapStateToProps, mapDispatchToProps)(SiderMenu);